// import { useRef, useState, useEffect, useCallback } from "react";
// import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

// const initialPlaces = [
//   {
//     name: "HOUSE OF BASHŌ",
//     price: "95,000/- per night",
//     img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4edc78e2-6ec6-4bd2-5e8b-595541845900/public",
//     link: "/house-of-basho",
//   },
//   {
//     name: "VILLA CELEBRATION",
//     price: "55,000/- per night",
//     img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9276b15a-a56d-42ee-3cc1-d5c2f2abef00/public",
//     link: "/villa-celebration",
//   },
//   {
//     name: "VILLA SERENITY",
//     price: "₹55,000 / per night",
//     img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/8f2ee8b7-6293-44d7-0561-66937cdd9a00/public",
//     link: "/villa-serenity",
//   },
//   {
//     name: "VILLA ARCADIA",
//     price: "₹55,000 / per night",
//     img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/35dbcc1d-9094-4d19-d210-53e192896200/public",
//     link: "/villa-arcadia",
//   },
//   {
//     name: "VILLA LUXO",
//     price: "₹35,000 / per night",
//     img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ebed53d0-5111-4814-ce1d-21fda93a1c00/public",
//     link: "/villa-luxo",
//   },
//   {
//     name: "AQUA GRANDIOSA - 201",
//     price: "₹6,000 / per night",
//     img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/14ed8c8a-5fc9-457a-a1cb-6947377a0500/public",
//     link: "/aqua-grandiosa-201",
//   },
//   {
//     name: "VILLA VERA G-7",
//     price: "₹12,000 / per night",
//     img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/63f19bdc-9f23-4e5d-4fed-1fca2114e000/public",
//     link: "/villa-vera-G7",
//   },
//   {
//     name: "HOUSE OF TĀO",
//     price: "₹1,20,000 / per night",
//     img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/15ec4d20-0c51-46ea-f569-93194a31e600/public",
//     link: "https://taobysoham.com/",
//   },
// ];

// const PropertyCarousel = () => {
//   const [places, setPlaces] = useState(initialPlaces);
//   const scrollRef = useRef(null);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [isPaused, setIsPaused] = useState(false);

//   const scroll = useCallback(
//     (dir) => {
//       if (isAnimating || !scrollRef.current) return;
//       setIsAnimating(true);

//       const container = scrollRef.current;
//       const card = container.querySelector(".carousel-card");
//       const gap = 16;
//       const scrollAmount = card.offsetWidth + gap;

//       if (dir === "right") {
//         container.scrollBy({ left: scrollAmount, behavior: "smooth" });

//         setTimeout(() => {
//           setPlaces((prev) => [...prev.slice(1), prev[0]]);
//           container.scrollLeft = 0;
//           setIsAnimating(false);
//         }, 450);
//       } else {
//         setPlaces((prev) => [prev[prev.length - 1], ...prev.slice(0, -1)]);
//         container.scrollLeft = scrollAmount;

//         requestAnimationFrame(() => {
//           container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
//         });

//         setTimeout(() => setIsAnimating(false), 450);
//       }
//     },
//     [isAnimating],
//   );

//   useEffect(() => {
//     if (isPaused) return;
//     const interval = setInterval(() => scroll("right"), 3000);
//     return () => clearInterval(interval);
//   }, [scroll, isPaused]);

//   return (
//     <div className="px-4 md:px-12 xl:px-20 lg:pb-10 max-w-[2500px] mx-auto">
//       <h2 className="text-xl md:text-xl 2xl:text-3xl font-semibold mb-6 text-left">
//         Browse more Properties
//       </h2>

//       <div className="relative group">
//         <button
//           onClick={() => scroll("left")}
//           className="absolute left-[-15px] md:left-[-25px] top-1/2 -translate-y-1/2 z-30 bg-black/40 shadow-xl text-white p-3 rounded-full"
//         >
//           <FaArrowLeft size={10} />
//         </button>

//         <button
//           onClick={() => scroll("right")}
//           className="absolute right-[-15px] md:right-[-20px] top-1/2 -translate-y-1/2 z-30 bg-black/40 shadow-xl text-white p-3 rounded-full"
//         >
//           <FaArrowRight size={10} />
//         </button>

//         <div
//           ref={scrollRef}
//           onMouseEnter={() => setIsPaused(true)}
//           onMouseLeave={() => setIsPaused(false)}
//           className="flex lg:gap-8 gap-4 overflow-hidden no-scrollbar py-6"
//         >
//           {places.map((item, i) => (
//             <a
//               key={`${item.name}-${i}`}
//               href={item.link}
//               className="carousel-card flex-shrink-0 bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-custom transition-all duration-300
//                 w-[calc(65%-8px)]
//                 md:w-[calc(40%-8px)]
//                 lg:w-[calc(32%-11px)]
//                 xl:w-[calc(24%-12px)]
//                 3xl:w-[calc(20%-13px)]"
//             >
//               <div className="relative h-52 overflow-hidden">
//                 <img
//                   src={item.img}
//                   alt={item.name}
//                   className="w-full h-full object-cover transition-transform duration-500"
//                 />
//               </div>
//               <div className="p-4 md:p-3">
//                 <h3 className="text-sm md:text-lg text-gray-900 uppercase truncate leading-tight">
//                   {item.name}
//                 </h3>
//                 <p className="text-gray-500 text-xs md:text-sm mt-1">
//                   {item.price}
//                 </p>
//               </div>
//             </a>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PropertyCarousel;
import { useRef, useState, useEffect, useCallback } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const initialPlaces = [
  {
    name: "HOUSE OF BASHŌ",
    price: "95,000/- per night",
    img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4edc78e2-6ec6-4bd2-5e8b-595541845900/public",
    link: "/house-of-basho",
  },
  {
    name: "VILLA CELEBRATION",
    price: "55,000/- per night",
    img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9276b15a-a56d-42ee-3cc1-d5c2f2abef00/public",
    link: "/villa-celebration",
  },
  {
    name: "VILLA SERENITY",
    price: "₹55,000 / per night",
    img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/8f2ee8b7-6293-44d7-0561-66937cdd9a00/public",
    link: "/villa-serenity",
  },
  {
    name: "VILLA ARCADIA",
    price: "₹55,000 / per night",
    img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/35dbcc1d-9094-4d19-d210-53e192896200/public",
    link: "/villa-arcadia",
  },
  {
    name: "VILLA LUXO",
    price: "₹35,000 / per night",
    img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ebed53d0-5111-4814-ce1d-21fda93a1c00/public",
    link: "/villa-luxo",
  },
  {
    name: "AQUA GRANDIOSA - 201",
    price: "₹6,000 / per night",
    img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/14ed8c8a-5fc9-457a-a1cb-6947377a0500/public",
    link: "/aqua-grandiosa-201",
  },
  {
    name: "VILLA VERA G-7",
    price: "₹12,000 / per night",
    img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/63f19bdc-9f23-4e5d-4fed-1fca2114e000/public",
    link: "/villa-vera-G7",
  },
  {
    name: "HOUSE OF TĀO",
    price: "₹1,20,000 / per night",
    img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/15ec4d20-0c51-46ea-f569-93194a31e600/public",
    link: "https://taobysoham.com/",
  },
];

const PropertyCarousel = () => {
  const [places, setPlaces] = useState(initialPlaces);
  const scrollRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  // ---------- FETCH VILLAS ----------
  useEffect(() => {
    const villaIds = [1, 2, 3, 4, 5, 12, 14, 18];

    Promise.all(
      villaIds.map((id) =>
        fetch(`https://sohamvillas.com/web-backend/villa/${id}`).then((res) =>
          res.json(),
        ),
      ),
    )
      .then((data) => {
        if (!Array.isArray(data)) {
          console.error("Unexpected response. Using fallback.");
          return;
        }

        const formatted = data.map((villa) => {
          if (villa.id === 18) {
            return {
              id: villa.id, // ✅ add this
              name: villa.villaName,
              price: `${villa.price.toLocaleString("en-IN")}/- per night`,
              img: villa.villaImg,
              link: "https://taobysoham.com",
              isExternal: true,
            };
          }

          const slug = villa.villaSlug;

          return {
            id: villa.id, // ✅ add this
            name: villa.villaName,
            price: `${villa.price.toLocaleString("en-IN")}/- per night`,
            img: villa.villaImg,
            link: `/${slug}/Goa/${villa.property_type}/adults=${villa.max_adults}/child=${villa.max_child}/bedroom=${villa.max_bedrooms}/bathroom=${villa.max_bathrooms}`,
            isExternal: false,
          };
        });

        setPlaces(formatted);
      })
      .catch(() => {
        console.error("Error fetching villas. Using fallback list.");
      });
  }, []);

  // ---------- CAROUSEL SCROLL LOGIC ----------
  const scroll = useCallback(
    (dir) => {
      if (isAnimating || !scrollRef.current) return;
      setIsAnimating(true);

      const container = scrollRef.current;
      const card = container.querySelector(".carousel-card");
      const gap = 16;
      const scrollAmount = card.offsetWidth + gap;

      if (dir === "right") {
        container.scrollBy({ left: scrollAmount, behavior: "smooth" });

        setTimeout(() => {
          setPlaces((prev) => [...prev.slice(1), prev[0]]);
          container.scrollLeft = 0;
          setIsAnimating(false);
        }, 450);
      } else {
        setPlaces((prev) => [prev[prev.length - 1], ...prev.slice(0, -1)]);
        container.scrollLeft = scrollAmount;

        requestAnimationFrame(() => {
          container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        });

        setTimeout(() => setIsAnimating(false), 450);
      }
    },
    [isAnimating],
  );

  // ---------- AUTOPLAY ----------
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => scroll("right"), 3000);
    return () => clearInterval(interval);
  }, [scroll, isPaused]);

  return (
    <div className="px-4 md:px-12 xl:px-20 lg:pb-10 max-w-[2500px] mx-auto">
      <h2 className="text-xl md:text-xl 2xl:text-3xl font-semibold mb-6">
        Browse more Properties
      </h2>

      <div className="relative group">
        <button
          onClick={() => scroll("left")}
          className="absolute left-[-15px] md:left-[-25px] top-1/2 -translate-y-1/2 z-30 bg-black/40 text-white p-3 rounded-full"
        >
          <FaArrowLeft size={10} />
        </button>

        <button
          onClick={() => scroll("right")}
          className="absolute right-[-15px] md:right-[-20px] top-1/2 -translate-y-1/2 z-30 bg-black/40 text-white p-3 rounded-full"
        >
          <FaArrowRight size={10} />
        </button>

        <div
          ref={scrollRef}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          className="flex lg:gap-8 gap-4 overflow-hidden no-scrollbar py-6"
        >
          {places.map((item, i) => (
            <a
              key={`${item.name}-${i}`}
              href={item.link}
              target={item.id === 18 ? "_blank" : "_self"}
              rel={item.id === 18 ? "noopener noreferrer" : ""}
              className="carousel-card flex-shrink-0 bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-custom transition-all duration-300
      w-[calc(65%-8px)]
      md:w-[calc(40%-8px)]
      lg:w-[calc(32%-11px)]
      xl:w-[calc(24%-12px)]
      3xl:w-[calc(20%-13px)]"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-3">
                <h3 className="text-sm md:text-lg text-gray-900 uppercase truncate">
                  {item.name}
                </h3>
                <p className="text-gray-500 text-xs md:text-sm mt-1">
                  {item.price}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PropertyCarousel;
